import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import {setUiMode, setObjectMode, emptyEditObject} from '../../actions'
import List from '../List'
import Form from '../Form'
import { I18n, translate } from 'react-i18next'
import { isDirty } from 'redux-form'
import { toastr } from 'react-redux-toastr'
import GlyphiconButton from './GlyphiconButton'
import Accordion from '../../../../components/Accordion'
import Chart from '../Graph/index'
import './ModuleAccordion.css'
import { iconSelector } from '../../../../utils/iconSelector'
import { loadDefaultEdit } from '../../actions/module'
import {
    getModule,
    getListIcon,
    getFormIcon,
    getEditFieldsLength,
    getFiltersExist,
    getGroupModel,
    getLanguage,
    getDataTableObjects
} from '../../selectors/index'
import {Plus, ChartPie, LineChart, BarChart3, Shuffle, Table2 as TableIcon, ChartColumnStacked, ChartArea} from 'lucide-react'
import { OBJECT_FORM } from '../Form'

export const chartIcons = {
    donutChart: ChartPie,
    lineChart: LineChart,
    barChart: BarChart3,
    stackedBarChart: ChartColumnStacked,
    stackedAreaChart: ChartArea,
};

class ModuleAccordion extends PureComponent {
    renderHeading = () => {
        const {
            module,
            mode,
            setUiMode,
            listIcon,
            formIcon,
            confirmAndSetUiMode,
            setObjectMode,
            openFormWithDefaultData,
            isFormDirty,
            menuButtonsColor,
            selectedColor,
            objects
        } = this.props

        const category = module.category
        const path = category.path ? category.path : category
        const icon = category.icon

        return (
            <div className="Module-header">
                <I18n ns={[module.model, 'platform']}>
                    {t => (
                        <div className="Module-title-container">
                            {iconSelector(
                                icon || path,
                                'Module-menu-icon',
                                menuButtonsColor
                            )}
                            <p className="Module-menu-title" style={{color: menuButtonsColor}}>
                                {t(path)}
                            </p>
                            {iconSelector(
                                'rightChevron',
                                'Module-title-icon',
                                selectedColor
                            )}
                            <p className="Module-title" style={{color: selectedColor}}>
                                {t(module.tKey)}
                            </p>
                        </div>
                    )}
                </I18n>
                <div className="ModuleAccordion-panel-buttons-div">
                    <I18n ns={[module.model, 'platform']}>
                        {t => (
                            <div className="btn-group ModuleAccordion-buttons">
                                {module.impExp &&
                                mode !== 'impExp' && (
                                    <GlyphiconButton
                                        backgroundColor="rgb(250 252 254)"
                                    >
                                        <Shuffle style={{color: '#fefefe'}} size={15} />
                                    </GlyphiconButton>
                                )}
                                {
                                    !!module.charts?.length && (
                                        <>
                                            {
                                                module.charts.map(chart => {
                                                    const Icon = chartIcons[chart.type];
                                                    return (
                                                        <GlyphiconButton
                                                            backgroundColor="snow"
                                                            onClick={() => {
                                                                setUiMode(chart.type)
                                                            }}
                                                        >
                                                            <Icon size={15}/>
                                                        </GlyphiconButton>
                                                    )
                                                })
                                            }
                                        </>
                                    )
                                }
                                { listIcon && module.listable &&
                                mode !== 'list' && (
                                    <GlyphiconButton
                                        backgroundColor="#8d8d8d"
                                        onClick={() => {
                                            confirmAndSetUiMode('list', isFormDirty)
                                        }}
                                    >
                                        <TableIcon style={{color: 'rgb(234 234 234)'}} size={15} />
                                    </GlyphiconButton>
                                )}
                                {formIcon &&
                                module.newable &&
                                mode !== 'form' && (
                                    <GlyphiconButton
                                        backgroundColor="#1f75cb"
                                        borderColor="#2f68b4"
                                        onClick={() => {
                                            setObjectMode('newObject')
                                            openFormWithDefaultData()
                                        }}
                                    >
                                        <Plus style={{color: 'white'}} size={17} />
                                    </GlyphiconButton>
                                )}
                            </div>
                        )}
                    </I18n>
                </div>
            </div>
        )
    }

    static renderPanel(key, t, props) {
        // Only the active panel mounts its content. The list panel and every chart
        // panel each render their own ListFilterForm; keeping the hidden ones
        // mounted puts several date-range pickers on screen that all share the same
        // redux open-state (keyed by filter id). A click on the month/year
        // navigation of the visible calendar then reads as an outside-click for the
        // hidden pickers, which dispatch "close" and collapse the calendar before
        // the month/year panel can open.
        // The form panel is gated too: it holds the reduxForm('editObject') form, so
        // unmounting it on close lets destroyOnUnmount wipe state.form.editObject and
        // every open starts from a clean initialize instead of the previous record's
        // values. (mainAccordion renders into a static, non-animated div, so this
        // does not reintroduce the panel-resize flicker.)
        const openedPanel = props.openedPanel || 'list'
        const isActive = openedPanel === key

        switch (key) {
            case 'list':
                return isActive ? <List t={t} {...props}/> : null
            case 'form':
                return isActive ? <Form t={t} {...props}/> : null
            case 'donutChart':
            case 'lineChart':
            case 'barChart':
            case 'stackedBarChart':
            case 'stackedAreaChart':
            case 'dynamicBarChart':
            case 'stackedMultipleBarChart': {
                if (!isActive) return null
                const chartParams = props.module.charts?.find(chart => chart.type === key)
                return chartParams ? <Chart t={t} type={key} chartParams={chartParams} {...props}/> : null
            }
            default:
                return isActive ? <List t={t} {...props}/> : null
        }
    }

    render() {
        const {mode, module, groupModel, language, selectedColor, filtersExist} = this.props

        return (
            <div className="Module-container">
                <Accordion
                    renderHeading={this.renderHeading}
                    renderPanel={ModuleAccordion.renderPanel}
                    openedPanel={mode}
                    panelKeys={['list', 'form', 'lineChart', 'donutChart', 'barChart', 'stackedBarChart', 'stackedAreaChart', 'dynamicBarChart', 'stackedMultipleBarChart']}
                    fillAllHeight={true}
                    panelClassName="panel-body"
                    mainAccordion={true}
                    module={module}
                    groupModel={groupModel}
                    language={language}
                    model={module.model}
                    selectedColor={selectedColor}
                    filtersExist={filtersExist}
                />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    mode: state.ui.mode,
    module: getModule(state),
    groupModel: getGroupModel(state),
    language: getLanguage(state),
    listIcon: getListIcon(state),
    formIcon: getFormIcon(state),
    filtersExist: getFiltersExist(state),
    editFieldsLength: getEditFieldsLength(state),
    isFormDirty: isDirty(OBJECT_FORM)(state),
    objects: getDataTableObjects(state)
})

const mapDispatchToProps = (dispatch, { t }) => ({
    setUiMode: panel => dispatch(setUiMode(panel)),
    emptyEditObject: () => dispatch(emptyEditObject()),
    confirmAndSetUiMode: (panel, isFormDirty) => {
        if(isFormDirty) {
            toastr.confirm(t('quittingFormConfirmation'), {
                onOk: () => dispatch(setUiMode(panel))
            })
        } else {
            dispatch(setUiMode(panel))
            dispatch(emptyEditObject())
            dispatch(setObjectMode(''))
        }
    },
    setObjectMode: mode => dispatch(setObjectMode(mode)),
    openFormWithDefaultData: () => dispatch(loadDefaultEdit()),
})

export default translate('platform')(
    connect(mapStateToProps, mapDispatchToProps)(ModuleAccordion)
)
